const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  id: "outline/wallet"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector (Stroke)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.166016 3.99996C0.166016 2.98744 0.986827 2.16663 1.99935 2.16663H11.9993C12.6437 2.16663 13.166 2.68896 13.166 3.33329V4.66663C13.166 4.72321 13.162 4.77886 13.1542 4.83329H14.666C15.3103 4.83329 15.8327 5.35563 15.8327 5.99996V13.3333C15.8327 13.9776 15.3103 14.5 14.666 14.5H1.99935C0.986826 14.5 0.166016 13.6791 0.166016 12.6666V3.99996ZM11.9993 4.83329C12.0914 4.83329 12.166 4.75867 12.166 4.66663V3.33329C12.166 3.24125 12.0914 3.16663 11.9993 3.16663H1.99935C1.53911 3.16663 1.16602 3.53972 1.16602 3.99996V4.83329H11.9993ZM1.16602 5.83329V12.6666C1.16602 13.1269 1.53911 13.5 1.99935 13.5H14.666C14.7581 13.5 14.8327 13.4253 14.8327 13.3333V5.99996C14.8327 5.90791 14.7581 5.83329 14.666 5.83329H1.16602ZM12.3327 9.16663C12.0565 9.16663 11.8327 9.39048 11.8327 9.66663C11.8327 9.94277 12.0565 10.1666 12.3327 10.1666C12.6088 10.1666 12.8327 9.94277 12.8327 9.66663C12.8327 9.39048 12.6088 9.16663 12.3327 9.16663ZM10.8327 9.66663C10.8327 8.8382 11.5043 8.16663 12.3327 8.16663C13.1611 8.16663 13.8327 8.8382 13.8327 9.66663C13.8327 10.4951 13.1611 11.1666 12.3327 11.1666C11.5043 11.1666 10.8327 10.4951 10.8327 9.66663Z",
  fill: "#3176C2"
}));

const SvgWallet = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWallet, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wallet.3e29c8b4.svg";
export { ForwardRef as ReactComponent };